
import {
  Box,
} from "@mui/material";
import { MHeaderSection } from "components/MHeaderSection";
import { MFilterSection, MListSection } from "features/searchStore/sections/SearchResult";

export function MobileView() {
  return (
    <Box display="flex" width="100vw" flexDirection="column">
      {/* Header */}
      <MHeaderSection />

      {/* Filter */}
      <MFilterSection />

      {/* Tab */}
      <MListSection />
    </Box>
  );
}
